// extracted by mini-css-extract-plugin
module.exports = {"equipmentpageTitleIcon":"EquipmentTitle_equipmentpageTitleIcon__spWg8"};